import React from "react";
import RenderApp from './index.js'
import ReactDOM from "react-dom";

ReactDOM.render(
    <RenderApp ></RenderApp>,
    document.getElementById('root')
  ); 